import { render, staticRenderFns } from "./editionInfo.vue?vue&type=template&id=626b0611&scoped=true&"
import script from "./editionInfo.vue?vue&type=script&lang=js&"
export * from "./editionInfo.vue?vue&type=script&lang=js&"
import style0 from "./editionInfo.vue?vue&type=style&index=0&id=626b0611&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b0611",
  null
  
)

export default component.exports